import { Fragment } from "react/jsx-runtime";
import ExternalLink from "../../Common/components/ExternalLink";
import { useGetUrlQuery } from "../../services/storage/api";
import { S3_PATHS } from "../../services/storage/constants";
import Card from "../../Common/components/Card";
import { Mui, MuiIcons } from "@osu/react-ui";

const complianceStyle = (theme) => ({
  color: theme.palette.primary.main,
});

const ExternalFAQ = ({ children, ...props }) => (
  <ExternalLink
    href="https://fsapartners.ed.gov/knowledge-center/topics/section-117-foreign-gift-and-contract-reporting/resources/frequently-asked-questions"
    {...props}
  >
    {children ||
      "Federal Student Aid Frequently Asked Questions on Section 117 of the Higher Education Act of 1965"}
  </ExternalLink>
);

function Compliance() {
  const { data = {} } = useGetUrlQuery({
    path: S3_PATHS.COMPLIANCE,
  }, {
    pollingInterval: 14 * 60 * 1000
  });
  const { href } = data;

  return (
    <Card title="Compliance Information" Icon={MuiIcons.AssuredWorkload}>
      <Mui.Typography variant="body2" sx={{ pb: 1 }}>
        The U.S. Department of Education requires Foreign Gift reporting to
        comply with Section 117 of the Higher Education Act (“Section 117”) (20
        U.S.C. § 1011f). Institutions that receive a gift from or enter into a
        contract with a foreign source (including through intermediaries such as
        a foundation), the value of which is $250,000 or more, considered alone
        or in combination with all other gifts from or contracts with that
        foreign source within a calendar year, must file a disclosure report.
      </Mui.Typography>
      <Mui.Typography variant="body2" sx={{ pb: 1 }}>
        Details of the federal reporting requirements and FAQs can be found
        here: <ExternalFAQ />.
        {href && (
          <Fragment>
            {" "}
            Details on OSU guidance can be found here:{" "}
            <Mui.Link variant="subtitle2" sx={complianceStyle} href={href}>
              OSU Info and FAQ's
              <sup>
                <MuiIcons.PictureAsPdf
                  fontSize="inherit"
                  titleAccess="opens PDF"
                />
              </sup>
            </Mui.Link>
            .
          </Fragment>
        )}
      </Mui.Typography>
    </Card>
  );
}

export default Compliance;
